<div mat-dialog-content>
  <div class="flex flex-col gap-4">
    <div class="grid grid-cols-5 items-center portal-toolbar">
      <div class="col-span-2">
        <span class="text-xl font-semibold">{{this.changeData.licenseGuid}} Change</span>
      </div>
      <div class="col-span-3 flex flex-col md:flex-row justify-self-end items-center gap-4 portal-actions">
        <button mat-button type="button" color="primary" (click)="submitChange()" *ngIf="changeForm.valid">Save</button>
        <button *ngIf="newChangeAdded" mat-button type="button" color="warn" (click)="cancel()">Close</button>
      </div>
    </div>

    <div class="flex flex-col gap-4" *ngIf="change.id > 0">

      <!--
        Change Entity Owner
      -->
      <div class="flex flex-col gap-4" *ngIf="changeData.entityType === sharedService.entityOwner">
        <div class="flex flex-col font-semibold text-xl" *ngIf="changeData.changeAction === sharedService.delete">
          Request to remove {{changeData.originalValue.firstName}} {{changeData.originalValue.lastName}} as an owner of the agency.
        </div>

        <div class="flex flex-col gap-4" *ngIf="changeData.changeAction === sharedService.change">
          Add each new owner that will be added to the agency.
          <span>The following are the steps for an IHC change of ownership. A license is specific to an owner and is not transferrable.
            Therefore, a new license must be generated when a change of ownership occurs. The steps to be completed are:</span>
          <span>1. Seller must submit an owner agreement letter which notifies this office of the change of ownership with the effective date;</span>
          <span>2. Buyer must also sign the above letter, or may submit a separate letter which confirms the change of ownership with effective date;</span>
          <span>5. Owner/Administrator Background Check Request forms must be submitted in conjunction with the application as applicable;</span>
          <span>6. Change of ownership fee must be submitted which is $350.00;</span>
          <span>8. The old license must be returned after the change of ownership effective date and once the new license is received.</span>
          <span>The Oregon Administrative Rules OARs for IHCs with which the new owner must comply, the IHC application form,
                the applicable background check forms for the administrator or owner(s), if applicable,
                are found at <a href="http://www.healthoregon.org/hcrqi">www.healthoregon.org/hcrqi</a></span>
        </div>

        <span class="font-semibold">An In-Home Care agency is defined in Oregon Revised Statute (ORS) 443.315 as:
          an agency primarily engaged in providing in-home care services for compensation to an
          individual in that individual’s place of residence.” Inhome care agency”
          does not include a home health agency or portion of an agency providing home health services as defined in ORS 443.005.</span>
        <span>1. I have read and I understand the In-Home Care licensure requirements
          set forth in ORS 443.305 to 443.350 and OARs Chapter 333, Division 536.</span>
        <span>2. Written policies and procedures, including applicable forms and curriculums,
          have been developed to direct all administrative, personnel, and client care operations of the agency.
          The policies and procedures are complete, clear, and ensure compliance with the in-home care agency OARs.</span>
        <span>3. Client care and documentation systems have been developed and implemented to ensure compliance with the In-Home Care licensure OARs.</span>
        <span>4. Personnel management and documentation systems have been developed and implemented to
          ensure employees meet all screening, qualification, orientation, and training requirements consistent with the in-home care agency OARs.</span>
        <span>5. Branch offices operated by the IHC are managed as required by the In-Home Care OARs.
          Systems to ensure that the parent IHC maintains control and oversight of the branch office(s) have been developed and implemented.</span>
        <span class="font-semibold">I attest, under penalties of perjury, that I have answered all the above questions to the best of my knowledge and belief;
          and that this information is true, correct and complete. I assume full responsibility for the ongoing operations of the IHC,
          including all branch offices, and its compliance with the applicable OARs.</span>

        <entity-owner *ngIf="changeData.changeAction !== sharedService.delete"
                      [entityId]="change.id"
                      [entityType]="sharedService.inHomeCareChange"
                      [entityGuid]="changeData.licenseGuid"
                      [isChange]="true"></entity-owner>
      </div>

      <!--
        Change Administrator
      -->
      <div class="flex flex-col" *ngIf="changeData.entityType === sharedService.administratorApplication">
        <span>Provide information about the new administrator.</span>
        <administrator-application [entityId]="change.id"
                                   [entityType]="sharedService.inHomeCareChange"
                                   [isChange]="true">
        </administrator-application>
      </div>

      <!--
        Set As Parent Agency
      -->
      <div class="flex flex-col" *ngIf="changeData.entityType === sharedService.parent">
        <span class="font-semibold text-lg pb-4">Request to set {{changeData.newValue}} as the parent agency.</span>
        <span>Current Parent Agency: {{changeData.originalValue}}</span>
        <span>New Parent Agency: {{changeData.newValue}}</span>
      </div>

      <!--
        Change Branch Operation
      -->
      <div class="flex flex-col" *ngIf="changeData.entityType === sharedService.branchOperation">

        <div class="flex flex-col gap-2" *ngIf="changeData.changeAction === sharedService.add">
          <span>Oregon Administration Rule (OAR) 333-536-0050(3) states:</span>
          <span>3) If an agency operates a branch office:</span>
          <span>(a) The site of the branch office must not exceed 60 miles from the location of the parent agency or subunit.
            The branch office is part of the agency or subunit and must be located sufficiently close to share administration,
            supervision, and services in a manner that renders it unnecessary for the branch to
            independently meet the requirements of an agency.</span>
          <span>(b) The branch office shall be operated under the management and supervision of the parent agency or subunit
            in its geographic service area. Administrative and personnel functions, including but not limited to scheduling,
            training and record maintenance, must be retained at the parent agency or subunit.
            The branch office must not function as an independent agency.</span>
          <span>(c) Services must not be provided from the branch office until the branch office has been added to the
            license of the parent agency or subunit in accordance with Authority procedures.</span>

          <span>1. I have read and understand the IHC requirements set forth in ORS 443.305
            to 443.350 and OARs Chapter 333, Division 536.</span>
          <span>2. Written policies and procedures, including applicable forms and curriculums, to
            direct all administrative, personnel, and client care operations of the IHC, including
            for branch office operations, have been developed and implemented. The policies
            and procedures are complete, clear, and are compliant with the IHC OARs.</span>
          <span>3. The branch office operated by the IHC will be managed, staffed, and supervised
            by the parent IHC. Systems to ensure that the parent IHC maintains control and
            oversight of this branch office have been developed and implemented. </span>
          <span>4. I understand that the addition of this branch office does not allow the IHC to
            extend the provision of services beyond the geographic service area (60 miles) of
            the parent IHC. </span>
          <span>5. The branch office location is not more than 60 miles from the parent office
            location.</span>
          <span>I attest, under penalties of perjury, that this information is true, correct and
            complete. I assume full responsibility for the ongoing operations of the agency,
            including its branch office(s), and its compliance with all applicable OARs.</span>

          <branch-operation *ngIf="changeData.entityType === sharedService.branchOperation"
                            [entityId]="change.id"
                            [entityType]="sharedService.inHomeCareChange"
                            [agencyAddresses]="changeData.referenceAddresses"
                            [isChange]="true">
          </branch-operation>
        </div>

        <div class="flex flex-col gap-2" *ngIf="changeData.changeAction === sharedService.change">
          <span>Provide the new branch address.</span>
          <span>The new address must be within 60 miles of the agency address.</span>
          <span class="mt-4">Calculated Distance From Current Address: {{calculatedDistance}}</span>
          <address class="mt-4"
                   [entityId]="change.id"
                   [entityType]="sharedService.inHomeCareChange"
                   [limitEntries]="true"
                   [limitTo]="1"
                   [isChange]="true"
                   (updatedPhysicalAddress)="getAddressDistance()"
                   (reportDistance)="updateAddressDistance($event)"></address>
        </div>
      </div>

      <!--
        Change Classification
      -->
      <div class="flex flex-col gap-4" *ngIf="changeData.entityType === sharedService.classification">
        <span>Select the new classification you are requesting</span>
        <div class="flex flex-col" *ngIf="!changeData.isSubunit">
          <span>NOTE: Changing your agency classification to a higher level will incur a fee.</span>
          <span>Fee Rates:</span>
          <div class="flex flex-row gap-4">
            <span class="w-1/2">Limited to Basic</span>
            <span class="w-1/2">$250</span>
          </div>
          <div class="flex flex-row gap-4">
            <span class="w-1/2">Limited to Intermediate</span>
            <span class="w-1/2">$500</span>
          </div>
          <div class="flex flex-row gap-4">
            <span class="w-1/2">Limited to Comprehensive</span>
            <span class="w-1/2">$1000</span>
          </div>
          <div class="flex flex-row gap-4">
            <span class="w-1/2">Basic to Intermediate</span>
            <span class="w-1/2">$250</span>
          </div>
          <div class="flex flex-row gap-4">
            <span class="w-1/2">Basic to Comprehensive</span>
            <span class="w-1/2">$750</span>
          </div>
          <div class="flex flex-row gap-4">
            <span class="w-1/2">Intermediate to Comprehensive</span>
            <span class="w-1/2">$500</span>
          </div>
        </div>

        <mat-radio-group class="flex-col gap-2"
          aria-labelledby="classification level" [(ngModel)]="newValue">
          <mat-radio-button value="Limited">
            <span class="font-semibold text-lg underline pr-4">Limited</span>
            <span>An agency that provides personal care services that may include
              medication reminding but does not provide medication assistance, medication administration, or nursing
              services.</span>
          </mat-radio-button>
          <mat-radio-button value="Basic">
            <span class="font-semibold text-lg underline pr-4">Basic</span>
            An agency that provides personal care services that may include
            medication reminding and medication assistance but does not provide medication administration or nursing services.
          </mat-radio-button>
          <mat-radio-button value="Intermediate">
            <span class="font-semibold text-lg underline pr-4">Intermediate</span>
            An agency that provides personal care services thta may include
            medication reminding, medication assistance and medication administration but does not provicde nursing services.
          </mat-radio-button>
          <mat-radio-button value="Comprehensive">
            <span class="font-semibold text-lg underline pr-4">Comprehensive</span>
            An agency that provides personal care services that may include
            medication reminding, medication assistance, medication administration, and nursing services.
          </mat-radio-button>
        </mat-radio-group>
      </div>

      <!--
        Change Nurse
      -->
      <div class="flex flex-col" *ngIf="changeData.entityType === sharedService.nurse">
        <span>Provide the name of the new nurse</span>
        <span>An admin will confirm the new nurse's RN licensure with OSBN</span>
        <mat-form-field class="pt-4">
          <mat-label>Nurse Name</mat-label>
          <input matInput [(ngModel)]="newValue" placeholder="First Last">
        </mat-form-field>
      </div>

      <!--
        Change Address
      -->
      <div class="flex flex-col" *ngIf="changeData.entityType === sharedService.address">
        <span>Provide the new agency address.</span>
        <span>If the new address is greater than 60 miles from the current address it will need to be approved by an admin.</span>
        <span class="mt-4">Calculated Distance From Current Address: {{calculatedDistance}}</span>
        <address class="mt-4"
                 [entityId]="change.id"
                 [entityType]="sharedService.inHomeCareChange"
                 [limitEntries]="true"
                 [limitTo]="1"
                 [isChange]="true"
                 (updatedPhysicalAddress)="getAddressDistance()"
                 (reportDistance)="updateAddressDistance($event)"></address>
      </div>

      <!--
        Required Documents
      -->
      <document *ngIf="requiredDocumentTypes.length > 0"
                [entityId]="change.id"
                [entityType]="sharedService.inHomeCareChange"
                [types]="requiredDocumentTypes"></document>

      <!--
        Sign and Submit
      -->
      <div class="flex flex-col">
        <div class="flex flex-col" *ngIf="validationErrors.length > 0">
          <span class="font-semibold text-xl text-red-600">Missing Information</span>
          <div class="flex flex-col gap-2 text-red-600">
            <span *ngFor="let error of validationErrors">{{error}}</span>
          </div>
        </div>
        <form [formGroup]="changeForm">
          <div class="flex flex-col">
            <div class="flex flex-col md:flex-row gap-2 portal-field-grid">
              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Administrator Signaure</span>
                <mat-form-field>
                  <mat-label>Signature</mat-label>
                  <input matInput formControlName="signature">
                  <mat-error *ngIf="changeForm.get('signature').invalid">
                    A name is required
                  </mat-error>
                </mat-form-field>
              </div>

              <div class="flex flex-col gap-2 md:w-1/2">
                <span class="font-semibold">Title</span>
                <mat-form-field>
                  <mat-label>Title</mat-label>
                  <input matInput formControlName="title">
                </mat-form-field>
              </div>
            </div>

            <div class="flex flex-col md:flex-row gap-4">
              <div class="flex flex-col md:flex-row gap-2">
                <div class="flex flex-col gap-2">
                  <span class="font-semibold">Effective Date</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="effectiveDateOfChange" matInput
                      [matDatepicker]="effectiveDateOfChange" />
                    <mat-datepicker-toggle matSuffix [for]="effectiveDateOfChange"></mat-datepicker-toggle>
                    <mat-datepicker #effectiveDateOfChange>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="changeForm.get('effectiveDateOfChange').invalid">
                      Effective date required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>

              <div class="flex flex-col md:flex-row gap-2">
                <div class="flex flex-col gap-2">
                  <span class="font-semibold">Date Signed</span>
                  <mat-form-field>
                    <input placeholder="mm/dd/yyyy" formControlName="dateSigned" matInput [matDatepicker]="signed"
                      [max]="sharedService.today" />
                    <mat-datepicker-toggle matSuffix [for]="signed"></mat-datepicker-toggle>
                    <mat-datepicker #signed>
                      <mat-datepicker-actions>
                        <button mat-raised-button color="primary" matDatepickerApply>Apply</button>
                        <button mat-button matDatepickerCancel>Cancel</button>
                      </mat-datepicker-actions>
                    </mat-datepicker>
                    <mat-error *ngIf="changeForm.get('dateSigned').invalid">
                      Signature date required
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="flex flex-row gap-4 ml-auto portal-actions">
              <button *ngIf="changeForm.valid" mat-button type="button" color="primary" (click)="submitChange()">Save</button>
              <button *ngIf="newChangeAdded" mat-button type="button" color="warn" (click)="cancel()">Close</button>
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>
